import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../Teacher/Assests/Scss/AddStudent.scss";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { Alert } from "../../Student/Reusablecomponents/RegularFunctions";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../ReusableComponents/ToastifyAlerts";
const AddInstitute = (props) => {
  const dispatch = useDispatch();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const [ErrorMessage, setErrors] = useState({});
  const [InstituteDetails, SetInstituteDetails] = useState({
    Code: "",
    Name: "",
    Address: "",
    InstituteId: "",
  });

  useEffect(() => {
    if (props.EditDetails) {
      SetInstituteDetails({
        Code: props.EditDetails.instituteCode || "",
        Name: props.EditDetails.instituteName || "",
        Address: props.EditDetails.address || "",
        InstituteId: props.EditDetails.instituteId || "",
      });
    }
  }, [props.EditDetails]);

  const validationSchema = Yup.object().shape({
    Code: Yup.string()
      .matches(
        /^[A-Za-z\s]+$/,
        "Institute Code should only contain alphabets and spaces"
      )
      .max(50, "Institute Code cannot exceed 50 characters")
      .required("Institute Code is required")
      .test(
        "no-start-space",
        "Institute Code cannot start with a space",
        (value) => !/^\s/.test(value)
      ),
    Name: Yup.string().required("Institute Name is required"),
    Address: Yup.string().required("Institute Address is required"),
  });

  const SubmitForm = () => {
    const fullinstituteDetails = { ...InstituteDetails };
    validationSchema
      .validate(fullinstituteDetails, { abortEarly: false })
      .then(() => {
        PostAddInstitute(fullinstituteDetails);
      })
      .catch((err) => {
        const newErrors = {};
        err.inner.forEach((error) => {
          newErrors[error.path] = error.message;
        });
        setErrors(newErrors);
      });
  };

  const PostAddInstitute = async (fullinstituteDetails) => {
    const AddInstituteDetails = {
      instituteCode: fullinstituteDetails.Code,
      instituteName: fullinstituteDetails.Name,
      address: fullinstituteDetails.Address,
      addorUpdatedby: items.userId,
    };

    if (fullinstituteDetails.InstituteId) {
      AddInstituteDetails.instituteId = fullinstituteDetails.InstituteId;
    }

    if (props.EditDetails) {
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL + "/NCLAdmin/UpdateInstitute",
          AddInstituteDetails,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then(() => {
          props.Cancle(false);
          props.GetList();
          notify("Institute Updated successfully", "success");
        })
        .catch((err) => {
          notify("An error occurred while updating the institute. Please try again.", "error")
        });
    } else {
      await axios
        .post(
          process.env.REACT_APP_API_BASE_URL + "/NCLAdmin/InsertInstitute",
          AddInstituteDetails,
          { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
        )
        .then(() => {
          props.Cancle(false);
          props.GetList();
          notify("Institute saved successfully", "success");
        })
        .catch((err) => {
          notify("An error occurred while saving the institute. Please try again.", "error")
        });
    }
  };

  const FIllDetails = (e) => {
    const { name, value } = e.target;
    if (name === "Code") {
      SetInstituteDetails({
        ...InstituteDetails,
        [name]: value.toUpperCase(),
      });
    } else {
      const capitalizedValue =
        value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();

      SetInstituteDetails({
        ...InstituteDetails,
        [name]: capitalizedValue,
      });
    }
  };

  return (
    <div className="Card AddStudent-maindiv">
      <div className="dflex alignitems JSBetween">
        <div className="AddStudent-Title Helvetica">
          {props.EditDetails ? "Edit" : "Add"} Institute
        </div>
        <Alert />
        <IoMdCloseCircleOutline onClick={() => props.Cancle(false)} />
      </div>
      <div className="Student-Details-Form mt-3">
        <div className="dflex flexd-column" style={{ gap: "5px" }}>
          <label>
            Institute Code <span>*</span>
          </label>
          <input
            type="text"
            name="Code"
            placeholder="Enter Institute Code"
            value={InstituteDetails.Code}
            onChange={FIllDetails}
          />

          {ErrorMessage.Code && (
            <div className="error-message">{ErrorMessage.Code}</div>
          )}
        </div>

        <div className="dflex flexd-column" style={{ gap: "5px" }}>
          <label>
            Institute Name <span>*</span>
          </label>
          <input
            type="text"
            name="Name"
            placeholder="Enter Institute Name"
            value={InstituteDetails.Name}
            onChange={FIllDetails}
          />
          {ErrorMessage.Name && (
            <div className="error-message">{ErrorMessage.Name}</div>
          )}
        </div>

        <div className="dflex flexd-column" style={{ gap: "5px" }}>
          <label>
            Institute Address <span>*</span>
          </label>
          <input
            type="text"
            name="Address"
            placeholder="Enter Address"
            value={InstituteDetails.Address}
            onChange={FIllDetails}
          />
          {ErrorMessage.Address && (
            <div className="error-message">{ErrorMessage.Address}</div>
          )}
        </div>
      </div>

      <div className="AddStudent-Buttons dflex mt-3">
        <button className="Buttons" onClick={SubmitForm}>
          {props.EditDetails ? "Update" : "Save"}
        </button>
        <button className="Buttons" onClick={() => props.Cancle(false)}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default AddInstitute;
